const SHOW_GOALS_POPUP = 'SHOW_GOALS_POPUP';
export const SET_GOALS = 'SET_GOALS';

const initialState = {
  showDashboardGoalsPopup: false // wrapper that displays the white modal
};

export const goalsReducer = (goalsState = initialState, action = null) => {
  switch (action && action.type) {
    case SET_GOALS:
      return {
        ...goalsState,
        showDashboardGoalsPopup: false
      };

    case SHOW_GOALS_POPUP: // display the initial popup
      return {
        ...initialState, // reset popup to form each time it's launched
        showDashboardGoalsPopup: action.payload.showDashboardGoalsPopup
      };

    default:
      return goalsState;
  }
};

export const goalsActions = {
  setGoalsPopupView: (showDashboardGoalsPopup) => ({
    type: SHOW_GOALS_POPUP,
    payload: { showDashboardGoalsPopup }
  }),
  updateGoals: (updatedGoals) => ({
    type: SET_GOALS,
    payload: { updatedGoals: updatedGoals }
  })
};

export const goalsSelectors = {
  showDashboardGoalsPopup: (state) => state.goals.showDashboardGoalsPopup
};



// WEBPACK FOOTER //
// ./src/modules/launchpad/reducer/goals-reducer.js